import { SagaIterator } from 'redux-saga'
import { all, call, fork, put, select, takeEvery } from 'redux-saga/effects'

import { setARDData } from './actions'
import {
  ACTIVIDAD_RESERVA_DETALLE_GET,
  ACTIVIDAD_RESERVA_DETALLE_LOADING,
} from './types'

import { RootState } from '../../store'

import { notifications } from '@/common/helpers/notifications'
import { getActividadReservaBy } from '@/common/helpers/reservasServices'
import { Action } from '@/common/interfaces/general'
import { ActividadReserva, ActividadReservaDetalle } from '@/common/interfaces/respuestas'

function* getByARD({ payload }: Action<ActividadReserva>): SagaIterator {
  const { tipo } = yield select((state: RootState) => state.ReservasActions)

  try {
    yield put({ type: ACTIVIDAD_RESERVA_DETALLE_LOADING, payload: true })
    const { actividadReservaCabeceraId, bookingId, proveedorId, actividadId } =
      payload
    const ard: ActividadReservaDetalle[] = yield call(
      getActividadReservaBy,
      actividadReservaCabeceraId,
      bookingId,
      proveedorId,
      actividadId,
      tipo,
    )

    yield put(setARDData(ard))
  } catch (error) {
    notifications({ ex: error })
  } finally {
    yield put({ type: ACTIVIDAD_RESERVA_DETALLE_LOADING, payload: false })
  }
}

// whatcher
function* watchGetByActividadReservaDetalle(): Generator {
  yield takeEvery(ACTIVIDAD_RESERVA_DETALLE_GET, getByARD)
}

export default function* actividadReservaDetallesSaga(): Generator {
  yield all([fork(watchGetByActividadReservaDetalle)])
}
